<div *ngIf="gettingBranchDetails || gettingBranches" class="loadingOverlay center-loader">
  <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
  </p-progressSpinner>
</div>

<div class="container">
    <div class="branches-list-container">
        <div class="branches-list neo-scrollbar">
            <div class="neo-tabs">
                @for (branch of branchData; track $index) {
                <div class="neo-tab" [class.active]="openedBranch()?.id === branch.id" (click)="selectBranch(branch)">
                    {{branch.name}}
                </div>
                }
            </div>
        </div>
        @if (userPrivileges.has('branch.create')) {
        <div class="new-brach">
            <button *ngIf="userPrivileges.has('branch.create')" class="create-btn" pButton pRipple type="submit"
                label="Add New" (click)="openAddTemplate()"></button>
        </div>
        }
    </div>
    @if (openedBranch()) {
    <div class="branch-details neo-scrollbar" [formGroup]="branchDetails">
        <div class="neo-input-wrapper">
            <label for="branch_name" required>Branch Name</label>
            <input pInputText type="text" name="branch_name" id="branch_name"
                [readonly]="!userPrivileges.has('branch.update')" formControlName="name" placeholder="Branch Name">
        </div>
        <div class="neo-grid neo-grid-cols-2">
            <div class="neo-input-wrapper">
                <label for="official_email_id" required>Official Email Id</label>
                <input pInputText type="text" name="official_email_id" id="official_email_id"
                    [readonly]="!userPrivileges.has('branch.update')" formControlName="email"
                    placeholder="Official Email Id">
            </div>
            <div class="neo-input-wrapper">
                <label for="official_email_id">Mobile Number</label>
                <p-inputMask id="inputtext" mask="9999999999" [readonly]="!userPrivileges.has('branch.update')"
                    formControlName="mobile_number" placeholder="Mobile Number" />
            </div>
        </div>
        <div class="neo-grid neo-grid-cols-2">
            <div class="neo-input-wrapper">
                <label for="address_line_1" required>Address Line 1</label>
                <input pInputText type="text" name="address_line_1" id="address_line_1"
                    [readonly]="!userPrivileges.has('branch.update')" formControlName="address_line_1"
                    placeholder="Address Line 1">
            </div>
            <div class="neo-input-wrapper">
                <label for="address_line_2">Address Line 2</label>
                <input pInputText type="text" name="address_line_2" id="address_line_2"
                    [readonly]="!userPrivileges.has('branch.update')" formControlName="address_line_2"
                    placeholder="Address Line 2">
            </div>
        </div>
        <div class="neo-grid neo-grid-cols-2">
            <div class="neo-input-wrapper">
                <label for="area">Area</label>
                <input pInputText type="text" name="area" id="area" [readonly]="!userPrivileges.has('branch.update')"
                    formControlName="area" placeholder="Area">
            </div>
            <div class="neo-input-wrapper">
                <label for="city">City</label>
                <input pInputText type="text" name="city" id="city" [readonly]="!userPrivileges.has('branch.update')"
                    formControlName="city" placeholder="City">
            </div>
        </div>
        <div class="neo-grid neo-grid-cols-2">
            <div class="neo-input-wrapper">
                <label for="state">State</label>
                <input pInputText type="text" name="state" id="state" [readonly]="!userPrivileges.has('branch.update')"
                    formControlName="state" placeholder="State">
            </div>
            <div class="neo-input-wrapper">
                <label for="postal_code">Postal Code</label>
                <input pInputText type="text" name="postal_code" id="postal_code"
                    [readonly]="!userPrivileges.has('branch.update')" formControlName="postal_code"
                    placeholder="Postal Code">
            </div>
        </div>
    </div>
    <div class="template-footer" *ngIf="userPrivileges.has('branch.update') || userPrivileges.has('branch.delete')">
        <button class="delete-btn" *ngIf="userPrivileges.has('branch.delete')"
            [disabled]="!userPrivileges.has('branch.delete') || saveBtnLoading" pButton
            (click)="deleteBranch(openedBranch().id)">
            Delete
        </button>
        <button class="create-btn" *ngIf="userPrivileges.has('branch.update')"
            [disabled]="!userPrivileges.has('branch.update') || saveBtnLoading" pButton (click)="saveTemplate()"
            [loading]="saveBtnLoading">
            Save Changes
        </button>
    </div>
    } @else {
        <div class="branch-details neo-scrollbar">
            <empty-state *ngIf="!gettingBranchDetails && !gettingBranches">
                <empty-state-title>No Branches Found</empty-state-title>
                <empty-state-subtitle>Create a branch by clicking on "Add New".</empty-state-subtitle>
            </empty-state>
        </div>
    }
</div>

@if (false) {
<div class="pageInfo">
    <div style="display: flex;justify-content:space-between; align-items: center; width: 100%;">
        <div style="display: flex;justify-content:space-between; align-items: center;">
            <em class="pi pi-map-marker"></em>
            <p style="font-size: var(--fs-large); font-weight: var(--fw-bold);margin-left: 12.5px;">Branches</p>
        </div>
        <div>
            <button *ngIf="userPrivileges.has('branch.create')" style="height:38px; font-size:var(--fs-medium)" pButton pRipple type="submit" label="Add New"
                (click)="openAddTemplate()"></button>
        </div>
    </div>
</div>
<div class="info-card">
    <div class="branch-card" *ngFor="let branch of branchData; index as i">
        <div class="branch-card-header">
            <div class="branch-name-section">
                <div class="branch-icon">
                    <em class="pi pi-building"></em>
                </div>
                <h3 class="branch-name">{{ branch.name }}</h3>
            </div>
            <div class="branch-actions">
                <button *ngIf="userPrivileges.has('branch.update')" 
                        class="action-btn" 
                        (click)="editBranch(branch.id)" 
                        (keydown)="handleKeyDown($event, branch.id)"
                        title="Edit Branch">
                    <em class="pi pi-pencil"></em>
                </button>
                <button *ngIf="userPrivileges.has('branch.delete')" 
                        class="action-btn" 
                        (click)="deleteBranch(branch.id)" 
                        (keydown)="handleKeyDown($event, branch.id)"
                        title="Delete Branch">
                    <em class="pi pi-trash"></em>
                </button>
            </div>
        </div>        
        <div class="branch-card-content">
            <div class="branch-detail">
                <em class="branch-detail-icon pi pi-map-marker"></em>
                <p class="branch-detail-text">
                    {{ branch.address_line_1 }} {{ branch.address_line_2 }} {{ branch.area }} {{ branch.city }} {{ branch.state }} {{ branch.postal_code }}
                </p>
            </div>
            
            <div class="branch-detail" *ngIf="branch.mobile_number">
                <em class="branch-detail-icon pi pi-phone"></em>
                <p class="branch-detail-text">{{ branch.mobile_number }}</p>
            </div>
            
            <div class="branch-detail" *ngIf="branch.email">
                <em class="branch-detail-icon pi pi-at"></em>
                <p class="branch-detail-text">{{ branch.email }}</p>
            </div>
        </div>
    </div>
</div>
}

<p-dialog header="Add Branch" (visibleChange)="addTemplateSidebar = $event" [visible]="!edit && addTemplateSidebar" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false" (onHide)="branchDetails.reset(); selectBranch(openedBranch())">
    
    <div [formGroup]="branchDetails" style="width: 50vw;">
        <div class="dialog-content">
            <div class="neo-input-wrapper">
                <label for="name" required>Branch Name</label>
                <input type="text" pInputText inputId="text" formControlName="name" [(ngModel)]="branchName"
                    [ngClass]="{ 'invalid': clicked && branchDetails.controls['name'].errors}" placeholder="Branch Name" />
                <app-handle-error [clicked]="clicked" [control]="branchDetails.get('name')" name="Branch Name"></app-handle-error>
            </div>
            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label for="official_email_id" required>Official Email ID</label>
                    <input type="text" id="official_email_id" pInputText formControlName="email"
                        [ngClass]="{'invalid': clicked && branchDetails.controls['email'].errors}" placeholder="Official Email ID">
                    <app-handle-error [clicked]="clicked" [control]="branchDetails.get('email')"
                        name="Official Email ID"></app-handle-error>
                </div>
                <div class="neo-input-wrapper">
                    <label for="mobile_number">Mobile Number</label>
                    <p-inputMask id="mobile_number" mask="9999999999" formControlName="mobile_number" placeholder="Mobile Number">
                    </p-inputMask>
                    <app-handle-error [clicked]="clicked" [control]="branchDetails.get('mobile_number')"
                        name="Mobile Number"></app-handle-error>
                </div>
            </div>
            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label for="address_line_1" required>Address Line 1</label>
                    <input type="text" id="address_line_1" pInputText formControlName="address_line_1"
                        [ngClass]="{'invalid': clicked && branchDetails.controls['address_line_1'].errors}"
                        placeholder="Address Line 1">
                    <app-handle-error [clicked]="clicked" [control]="branchDetails.get('address_line_1')"
                        name="Address Line 1"></app-handle-error>
                </div>
                <div class="neo-input-wrapper">
                    <label for="address_line_2">Address Line 2</label>
                    <input type="text" id="address_line_2" pInputText formControlName="address_line_2"
                        [ngClass]="{'invalid': clicked && branchDetails.controls['address_line_2'].errors}"
                        placeholder="Address Line 2">
                    <app-handle-error [clicked]="clicked" [control]="branchDetails.get('address_line_2')"
                        name="Address Line 2"></app-handle-error>
                </div>
            </div>
            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label for="area">Area</label>
                    <input type="text" id="area" pInputText formControlName="area"
                        [ngClass]="{'invalid': clicked && branchDetails.controls['area'].errors}"
                        placeholder="Area">
                    <app-handle-error [clicked]="clicked" [control]="branchDetails.get('area')"
                        name="Area"></app-handle-error>
                </div>
                <div class="neo-input-wrapper">
                    <label for="city">City</label>
                    <input type="text" id="city" pInputText formControlName="city"
                        [ngClass]="{'invalid': clicked && branchDetails.controls['city'].errors}"
                        placeholder="City">
                    <app-handle-error [clicked]="clicked" [control]="branchDetails.get('city')"
                        name="City"></app-handle-error>
                </div>
            </div>
            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label for="state">State</label>
                    <input type="text" id="state" pInputText formControlName="state"
                        [ngClass]="{'invalid': clicked && branchDetails.controls['state'].errors}"
                        placeholder="State">
                    <app-handle-error [clicked]="clicked" [control]="branchDetails.get('state')"
                        name="State"></app-handle-error>
                </div>
                <div class="neo-input-wrapper">
                    <label for="postal_code">Postal Code</label>
                    <input type="text" id="postal_code" pInputText formControlName="postal_code"
                        [ngClass]="{'invalid': clicked && branchDetails.controls['postal_code'].errors}"
                        placeholder="Postal Code">
                </div>
            </div>
        </div>
        <div class="dialog-action">
            <button pButton pRipple pButton pRipple type="submit" label="Save" class="create-btn" (click)="saveTemplate()"
                [loading]="saveBtnLoading"></button>
        </div>
    </div>

    @if (false) {
    <div class="addTemplate-header">
        <div class="addTemplate-heading"><em style="margin-right: 12.5px;" class="pi pi-map-marker"></em>Add New Branch
        </div>
        <div class="header-btn">
            <button pButton pRipple type="submit" label="Cancel" (click)='cancel()'
                class="p-button-outlined button-align save-btn"></button>
            <button pButton pRipple type="submit" label="Save" (click)="saveTemplate()"
                class="p-button-raised p-button-text button-align" [loading]="saveBtnLoading"></button>
        </div>
    </div>
    <p-divider class="p-divider"></p-divider>
    <div class="templateForm" [formGroup]="branchDetails">

        <div class="form-salary branchForm-elements">
            <span class="p-input-icon-right p-float-label branchForm-elements">
                <input class="inputtext" style="width: 100%" type="text" pInputText inputId="text"
                    formControlName="name" [(ngModel)]="branchName"
                    [ngClass]="{ 'p-filled': branchName, 'invalid': clicked && branchDetails.controls['name'].errors}"
                    [style]="{ cursor: 'pointer' }" />
                <label for="dropdown">Branch Name<span [style]="{ color: '#E24A47' }"> *</span></label>
                <app-handle-error [clicked]="clicked" [control]="branchDetails.get('name')"
                    name="Branch Name"></app-handle-error>
            </span>
        </div>
        <span class="p-float-label">
            <p-inputMask id="inputtext" mask="9999999999" formControlName="mobile_number">
            </p-inputMask>
            <label for="inputtext">Mobile Number</label>
            <app-handle-error [clicked]="clicked" [control]="branchDetails.get('mobile_number')"
                name="Mobile Number"></app-handle-error>
        </span>
        <span class="p-float-label templateForm-elements">
            <input class="inputtext" type="text" id="template-title" pInputText formControlName="email"
                [ngClass]="{'p-filled': branchDetails.value.email, 'invalid': clicked && branchDetails.controls['email'].errors}">
            <label for="template-title">Official Email ID <span [style]="{color: '#E24A47'}"> *</span></label>
            <div *ngIf="(clicked && branchDetails.get('email')?.hasError('pattern'))">
                <span class="error-msg"> Enter a valid Email ID </span>
            </div>
            <app-handle-error [clicked]="clicked" [control]="branchDetails.get('email')"
                name="Official Email ID"></app-handle-error>
        </span>
        <span class="p-float-label templateForm-elements">
            <input class="inputtext" type="text" id="template-title" pInputText formControlName="address_line_1"
                [ngClass]="{'p-filled': branchDetails.value.address_line_1, 'invalid': clicked && branchDetails.controls['address_line_1'].errors}">
            <label for="template-title">Address Line 1 <span [style]="{color: '#E24A47'}"> *</span></label>
            <app-handle-error [clicked]="clicked" [control]="branchDetails.get('address_line_1')"
                name="Address Line 1"></app-handle-error>
        </span>
        <span class="p-float-label templateForm-elements">
            <input class="inputtext" type="text" id="template-title" pInputText formControlName="address_line_2"
                [ngClass]="{'p-filled': branchDetails.value.address_line_2}">
            <label for="template-title">Address Line 2</label>
            <app-handle-error [clicked]="clicked" [control]="branchDetails.get('address_line_2')" name="Address Line 2"></app-handle-error>
        </span>
        <span class="p-float-label templateForm-elements">
            <input class="inputtext" type="text" id="template-title" pInputText formControlName="area"
                [ngClass]="{'p-filled': branchDetails.value.area}">
            <label for="template-title">Area</label>
            <app-handle-error [clicked]="clicked" [control]="branchDetails.get('area')" name="Area"></app-handle-error>
        </span>
        <span class="p-float-label templateForm-elements">
            <input class="inputtext" type="text" id="template-title" pInputText formControlName="city"
                [ngClass]="{'p-filled': branchDetails.value.city}">
                <app-handle-error [clicked]="clicked" [control]="branchDetails.get('city')" name="City"></app-handle-error>
            <label for="template-title">City</label>
        </span>
        <span class="p-float-label templateForm-elements">
            <input class="inputtext" type="text" id="template-title" pInputText formControlName="state"
                [ngClass]="{'p-filled': branchDetails.value.state}">
                <app-handle-error [clicked]="clicked" [control]="branchDetails.get('state')" name="State"></app-handle-error>
            <label for="template-title">State</label>
        </span>
        <span class="p-float-label templateForm-elements">
            <input class="inputtext" type="text" id="template-title" pInputText formControlName="postal_code"
                [ngClass]="{'p-filled': branchDetails.value.postal_code}">
            <label for="template-title">Postal Code</label>
        </span>
    </div>
    }
</p-dialog>